import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, checked } = useAuth();
  const loc = useLocation();
  if (!checked) return <div className="p-8 text-slate-500">Loading...</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (roles) {
    const owned = new Set([user.role, ...(user.roles || [])]);
    if (!roles.some(r => owned.has(r))) {
      return <div className="p-8 text-slate-700">You don't have access to this section.</div>;
    }
  }
  return children;
}
